import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { API_CONFIG } from '../config/api.config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);

  // En SSR no hacemos nada
  if (!isBrowser) {
    return next(req);
  }

  // Solo aplicar interceptor a peticiones de nuestra API
  const isOurApi = req.url.includes(API_CONFIG.baseUrl);
  
  if (!isOurApi) {
    // Si no es nuestra API (ej: PayPhone), pasar la petición sin modificar
    return next(req);
  }

  // Preparar headers y opciones
  const headers: { [key: string]: string } = {};
  let withCredentials = false;

  if (API_CONFIG.cookie_http_only) {
    // Modo cookies HTTP-only: solo activar withCredentials para que el navegador envíe la cookie
    withCredentials = true;
  } else {
    // Modo JWT token tradicional
    const guestSessionId = localStorage.getItem(API_CONFIG.storage.guestSessionKey);
    const token = localStorage.getItem(API_CONFIG.storage.tokenKey);
    
    // Agregar guest_session_id como header
    if (guestSessionId) {
      headers['x-guest-session-id'] = guestSessionId;
    }
    
    // Agregar Authorization header si hay token
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  // Clonar la petición con los headers y credenciales
  const cloneOptions: any = {
    withCredentials: withCredentials
  };
  
  if (Object.keys(headers).length > 0) {
    cloneOptions.setHeaders = headers;
  }

  const clonedReq = req.clone(cloneOptions);

  return next(clonedReq);
};
